define([
	"dojo/_base/declare",
	"Apparel/model/productSource",
	"Apparel/NewStyle",
	"Apparel/NewStyleForm",
], function(declare, {SAMPLE_TO_COLLECTION_PATH, SAMPLE_TO_PRODUCT_PATH}, NewStyle, NewStyleForm) {

	const _NewStyleForm = declare(NewStyleForm, {
		/**
		 * @override
		 * Return parent collection of the Sample
		 */
		_getParentURLOfClientNode() {
			return this.formInfo.parentUrl;
		}
	});

	return declare(NewStyle, {
		/**
		 * Return sample that style is being created from
		 * @returns {C8Node}
		 */
		getSample() {
			return this.m_formData.getParent();
		},

		/**
		 * @override
		 * Extension point for specifying form info
		 */
		onCreateFormInfo(formInfo) {
			const sample = this.getSample();
			const collection = this.m_cache.getPathNode(sample, SAMPLE_TO_COLLECTION_PATH);
			formInfo.parentUrl = collection.$URL;
			formInfo.parentAttributeId = "Hierarchy";
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Set defaults
		 */
		onCreatePopup(view) {
			this.inherited(arguments);

			const sample = this.getSample();
			const style = this.m_cache.getPathNode(sample, SAMPLE_TO_PRODUCT_PATH);
			view.addDefaultValue("ProductType", style.ProductType);
			view.addDefaultValue("Node Name", sample.$Name);
		},

		/**
		 * @override
		 * Add special controller for form
		 */
		onCreatePopupDefView(defView) {
			defView.classController = _NewStyleForm;
		},

		/**
		 * @override
		 * Specify path to get to parent Collection
		 */
		onDependencyPaths(paths) {
			paths.push(SAMPLE_TO_COLLECTION_PATH);
		},
	});
});
